import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressContainer = _resolveComponent("AddressContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AddressContainer, {
      name: "Billing",
      id: _ctx.component.id,
      passedAddress: _ctx.renderStore.donor.billingAddress,
      required: _ctx.component.customData.required,
      address1Label: _ctx.component.customData.billingAddress1Label,
      address1Placeholder: _ctx.component.customData.billingAddress1Placeholder,
      address2Placeholder: _ctx.component.customData.billingAddress2Placeholder,
      cityPlaceholder: _ctx.component.customData.billingCityPlaceholder,
      statePlaceholder: _ctx.component.customData.billingStatePlaceholder,
      postalPlaceholder: _ctx.component.customData.billingPostalPlaceholder,
      countryPlaceholder: _ctx.component.customData.billingCountryPlaceholder,
      onUpdateAddress: _ctx.updateBillingAddress,
      "is-shipping": false
    }, null, 8, ["id", "passedAddress", "required", "address1Label", "address1Placeholder", "address2Placeholder", "cityPlaceholder", "statePlaceholder", "postalPlaceholder", "countryPlaceholder", "onUpdateAddress"]),
    (_ctx.component.customData.enableShippingAddress)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["form-element-wrapper rd-relative", _ctx.isModalDisplay ? 'rd-mt-2.5' : 'rd-mt-4'])
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "shippingAddressChecked",
            class: "rd-relative",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shippingAddressChecked) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkShippingAddress && _ctx.checkShippingAddress(...args)))
          }, null, 544), [
            [_vModelCheckbox, _ctx.shippingAddressChecked]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            for: "shippingAddressChecked",
            class: "rd-text-xs rd-mb-0 rd-ml-2.5"
          }, "Provide separate shipping address", -1))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.shippingAddressChecked)
      ? (_openBlock(), _createBlock(_component_AddressContainer, {
          key: 1,
          class: _normalizeClass(_ctx.isModalDisplay ? 'rd-mt-2.5' : 'rd-mt-4'),
          name: "Shipping",
          id: _ctx.component.id,
          passedAddress: _ctx.renderStore.donor.shippingAddress,
          required: false,
          address1Label: _ctx.component.customData.shippingAddress1Label,
          address1Placeholder: _ctx.component.customData.shippingAddress1Placeholder,
          address2Placeholder: _ctx.component.customData.shippingAddress2Placeholder,
          cityPlaceholder: _ctx.component.customData.shippingCityPlaceholder,
          statePlaceholder: _ctx.component.customData.shippingStatePlaceholder,
          postalPlaceholder: _ctx.component.customData.shippingPostalPlaceholder,
          countryPlaceholder: _ctx.component.customData.shippingCountryPlaceholder,
          onUpdateAddress: _ctx.updateShippingAddress,
          "is-shipping": true
        }, null, 8, ["class", "id", "passedAddress", "address1Label", "address1Placeholder", "address2Placeholder", "cityPlaceholder", "statePlaceholder", "postalPlaceholder", "countryPlaceholder", "onUpdateAddress"]))
      : _createCommentVNode("", true)
  ], 64))
}